'use strict';

var App = require('app');
var Consts = require('consts');
var Device = require('models/devices');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');

var ScanDevicesDialogView = Marionette.ItemView.extend({
    template: require('components/devices/templates/common/scan_devices_dialog'),

    ui: {
        btnSave: '#js-save',
    },

    events: {
        'click @ui.btnSave': 'save',
    },

    getInitMeterScan: function () {
        return { addrList: [], currentAddr: 0 };
    },

    initialize: function (options) {
        this.options = options;

        this.scanMaxSteps = 255; // + nr. detected M-Bus devices
        this.scanCount = 0;

        this.unitIDcurrent = 0;
        this.unitIDmax = 254;
        this.meterAddrListReceived = false;

        this.foundNewDevice = false;
        this.scanCancelled = false;
        this.scanRequestActive = false;

        this.canScanDevices = this.deviceScanAllowed();

        this.devices = [];

        var self = this;
        $('#js-modal-dialog').one('hidden.bs.modal', function () {
            self.scanCancelled = true;
        });

        this.samlanInit = this.samlanInitScanPossible();
        this.samlanGateways = {};
        this.samlanParentSerials = {};

        if (this.samlanInit) {
            this.scanMaxSteps = 1;
            this.samlanAgg = this.options.parentDevice;
            this.samlanScanInitialize();
        } else {
            this.scanNextMeter(true);
        }
    },

    scanNextMeter: function (isInit) {
        if (isInit) {
            this.meterScan = this.getInitMeterScan();
        }

        var devId = this.options.parentDevice.id;
        var self = this;

        var req = App.requestSilent('meter:scan', devId, this.meterScan.addrList[this.meterScan.currentAddr]);
        $.when(req).done(function (result) {
            if (isInit) {
                self.meterScan.addrList = _.map(_.pairs(result), function (row) {
                    return { addr: row[0], idx: row[1] };
                });
                self.meterScan.currentAddr = 0;
                self.meterAddrListReceived = true;

                self.scanMaxSteps += self.meterScan.addrList.length;

                if (self.meterScan.addrList.length > 0) {
                    self.scanNextMeter();
                } else {
                    self.scanNextDevice(!self.options.parentDevice.isEthernetController());
                }
            } else {
                self.scanCount += 1;

                _.each(result, function (meterType) {
                    self.devices.push({
                        type: meterType,
                        category: 'meter',
                        categoryKey: Consts.CategoryData.Meter.category,
                        image: 'meter_' + meterType + '.png',
                        unit: self.meterScan.addrList[self.meterScan.currentAddr].addr,
                        idx: self.meterScan.addrList[self.meterScan.currentAddr].idx,
                    });
                    if (!self.isDestroyed) {
                        self.render();
                    }
                });

                self.meterScan.currentAddr++;
                if (self.meterScan.currentAddr < self.meterScan.addrList.length) {
                    self.scanNextMeter();
                } else {
                    self.scanNextDevice(!self.options.parentDevice.isEthernetController());
                }
            }
        });
    },

    deviceScanAllowed: function () {
        var category = this.options.parentDevice.get('category');
        var type = this.options.parentDevice.get('type');

        // device scan allowed for all "regular" gateways
        if (category == Consts.Category.Gateway) {
            return true;
        }

        // device scan allowed for directly connected 5578-E controller
        if (this.options.parentDevice.isEthernetController()) {
            return this.options.parentDevice.isDirectlyConnected();
        }

        // device scan allowed for SAM LAN aggregation nodes
        if (category == Consts.Category.GatewayRF && type == '5016') {
            return true;
        }

        return false;
    },

    samlanInitScanPossible: function () {
        var category = this.options.parentDevice.get('category');
        var type = this.options.parentDevice.get('type');
        var firmware = this.options.parentDevice.get('firmware');

        var isAggregationNode = category == Consts.Category.GatewayRF && type != '5016_pn';
        var isFirmwareSufficient = Misc.isFirmwareSufficient(firmware, '2.2.0');

        return isAggregationNode && isFirmwareSufficient;
    },

    samlanScanInitialize: function () {
        var self = this;

        var scanResult = App.requestSilent('controller:scan:samlan', this.options.parentDevice.id);
        $.when(scanResult).done(function (result) {
            self.scanCount += 1;
            if (result && result.devices && !result.error) {
                self.samlanProcessScanResult(result.devices);
            }

            // proceed with normal scanning
            self.scanRequestActive = false;
            if (!self.isDestroyed) {
                self.render();
                self.scanNextMeter(true);
            }
        });
    },

    samlanProcessScanResult: function (devices) {
        var self = this;
        _.each(devices, function (device) {
            if (device.serial != self.samlanAgg.get('serial')) {
                var children = device.unit !== 0 ? 1 : 0;
                if (self.samlanGateways[device.serial] && self.samlanGateways[device.serial].children !== undefined) {
                    children += self.samlanGateways[device.serial].children;
                }
                // add/overwrite samlan gateway
                self.samlanGateways[device.serial] = {
                    category: 'gateway',
                    categoryKey: 'GatewayRF',

                    type: '5016_pn',

                    firmware: device.firmware,
                    hardware: device.hardware,
                    serial: device.serial,

                    unit: self.samlanInferGwUnitID(device),
                    children: children,
                };
            }

            if (device.type !== 5016 && device.type !== 0 && device.unit !== 0) {
                // GW has controller - store its parent serial
                self.samlanParentSerials[device.unit] = parseInt(device.serial);
                self.pushDevice('' + device.type, device.hardware, device.unit);
            }
        });
    },

    samlanInferGwUnitID: function (device) {
        if (device.type === 5016 && device.unit > 0) {
            // device has meter and thus a unitID addr -> store
            return device.unit;
        }

        // get existing unitID
        if (this.samlanGateways[device.serial]) {
            return this.samlanGateways[device.serial].unit;
        }

        return 0; // default
    },

    scanNextDevice: function (checkDefaultAddress) {
        if (this.samlanInit) {
            // skip for SAM LAN initialization
            return;
        }

        checkDefaultAddress = checkDefaultAddress || false;

        if (!this.canScanDevices) {
            this.unitIDcurrent = 0;
            this.unitIDmax = 0;
            this.scanMaxSteps -= 255;
            this.render();
        }
        if (this.scanCancelled || this.unitIDcurrent >= this.unitIDmax) {
            return;
        }

        var self = this;

        this.unitIDcurrent += checkDefaultAddress ? 0 : 1;
        this.scanRequestActive = true;

        var scanAddress = checkDefaultAddress ? 255 : this.unitIDcurrent;
        var scanResult = App.requestSilent('controller:scan', this.options.parentDevice.id, scanAddress);
        $.when(scanResult).done(function (result) {
            var type = result !== undefined ? result.get('type') : undefined;

            self.scanCount += 1;
            self.foundNewDevice =
                type !== undefined &&
                type !== '' &&
                scanAddress != 254 &&
                scanAddress != self.options.parentDevice.get('station') && // exclude current device
                type !== parseInt(Consts.GatewayTypeIDs.SAMMobile) &&
                type !== parseInt(Consts.GatewayTypeIDs.SAMMobilePlus) &&
                type !== parseInt(Consts.GatewayTypeIDs.SAMHome) &&
                type !== 55555; // SAM LAN Gateway error

            if (self.foundNewDevice) {
                self.pushDevice(type, result.get('hw'), scanAddress);
            }

            self.scanRequestActive = false;

            if (!self.isDestroyed) {
                self.render();
                self.scanNextDevice();
            }
        });
    },

    pushDevice: function (type, hw, scanAddress) {
        var category = 'modbus';
        var categoryKey = 'Modbus';

        var typePrex = type.indexOf != undefined && type.indexOf('_') >= 0 ? type.split('_')[0] : type;

        switch (parseInt(typePrex)) {
            case 5016:
                // RF-Gateway (peripheral node)
                type += '_pn';
                category = 'gateway';
                categoryKey = 'GatewayRF';
                break;
            case 5573:
            case 5575:
            case 5576:
            case 5578:
            case 5579:
                // controller
                category = 'controller';
                categoryKey = 'Controller';
                break;
            case 3374:
            case 3375:
            case 5724:
            case 5725:
                // actuator
                category = 'actuator';
                categoryKey = 'Actuator';
        }

        if (Consts.ControllerTypes[type] !== undefined) {
            category = 'controller';
            categoryKey = 'Controller';
        }

        var image = Device.GetImageName(
            { category: Consts.CategoryData[categoryKey].category, type: type, hardware: hw },
            true
        );

        // create new device
        this.devices.push({
            category: category,
            categoryKey: categoryKey,
            type: type,
            unit: scanAddress,
            image: image,
        });
    },

    onRender: function () {
        $('#animationSandbox')
            .removeClass()
            .addClass('bounceIn animated')
            .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
                $(this).removeClass();
            });
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.percent =
            this.scanMaxSteps == 0
                ? 100 // no devices detected
                : (this.scanCount * 100) / this.scanMaxSteps;
        data.percentDisplay = Math.round(data.percent);

        data.devices = _.values(this.samlanGateways).concat(this.devices);
        data.foundNewDevice = this.foundNewDevice;
        data.scanCancelled = this.scanCancelled;
        data.inAdding = this.inAdding;

        return data;
    },

    triggerAddDevice: function () {
        if (this.scanRequestActive) {
            // scanning still in progress -> wait half a second and try again
            var self = this;
            setTimeout(function () {
                self.triggerAddDevice();
            }, 500);
        } else {
            // scanning finished -> start adding devices
            if (this.samlanInit) {
                this.addSamlanGateway(0);
            } else {
                this.addDevice(0);
            }
        }
    },

    addSamlanGateway: function (key_idx) {
        var samlanSerials = Object.keys(this.samlanGateways);
        if (key_idx === samlanSerials.length) {
            // continue with controllers/meters
            this.addDevice(0);
            return;
        }

        var serial = samlanSerials[key_idx];
        var device = this.samlanGateways[serial];

        var newDeviceModel = this.createNewDeviceModel(device);

        var self = this;
        newDeviceModel.save(
            {},
            {
                success: function (model) {
                    // store id of newly added device
                    self.scanCount += 1;
                    self.samlanGateways[serial].deviceID = model.id;
                    self.render();
                    self.addSamlanGateway(key_idx + 1);
                },
                error: function (model, response) {
                    if (self.continueAfterError(response)) {
                        self.scanCount += 1;
                        self.samlanGateways[serial].deviceID = model.id || parseInt(response.responseJSON['#id']);
                        self.render();
                        self.addSamlanGateway(key_idx + 1);
                        return;
                    }
                    App.hideModal();
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR('Nicht alle gefundenen Geräte konnten hinzugefügt werden.')
                    );
                    Backbone.history.loadUrl(Backbone.history.fragment);
                },
            }
        );
    },

    addDevice: function (index) {
        // done?
        if (index == this.devices.length) {
            App.hideModal();
            Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Gerät hinzugefügt'));
            Backbone.history.loadUrl(Backbone.history.fragment);
            return;
        }

        this.render();

        // add device
        var device = this.devices[index];
        var newDeviceModel = this.createNewDeviceModel(device);

        var self = this;
        newDeviceModel.save(
            {},
            {
                success: function (model) {
                    self.scanCount += 1;
                    self.unitIDcurrent += 1;
                    self.render();
                    self.addDevice(index + 1);
                },
                error: function (model, response) {
                    if (self.continueAfterError(response)) {
                        self.scanCount += 1;
                        self.unitIDcurrent += 1;
                        self.render();
                        self.addDevice(index + 1);
                        return;
                    }

                    App.hideModal();
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR('Nicht alle gefundenen Geräte konnten hinzugefügt werden.')
                    );
                    Backbone.history.loadUrl(Backbone.history.fragment);
                },
            }
        );
    },

    continueAfterError: function (response) {
        // continue if device already exists or if modbus request failed for some reason
        return response.status === 400 || response.status === 502;
    },

    createNewDeviceModel: function (device) {
        var categoryData = Consts.CategoryData[device.categoryKey];
        var name =
            categoryData.name +
            (device.type === '5016_pn' ? ' - ' + i18n.TR('Reglerknoten') : '') +
            (device.serial && device.type === '5016_pn' ? ' ' + device.serial : '') +
            (device.unit > 0 ? ' #' + device.unit : '');
        var parent = this.getParentID(parseInt(device.unit));
        var wiredTo = this.options.parentDevice.get('wired_to');

        return new Device.Model({
            parent: parent,
            wired_to: wiredTo,
            name: name,
            station: parseInt(device.unit),
            key_number: 1732,
            category: categoryData.category,
            address: parseInt(device.unit),
            type: device.type,
            serial: device.serial ? String(device.serial) : undefined,
            firmware: device.firmware ? String(device.firmware) : undefined,
            hardware: device.hardware ? String(device.hardware) : undefined,
            children: device.children,
        });
    },

    getParentID: function (unitID) {
        if (unitID <= 0 || !this.samlanInit) {
            return this.options.parentDevice.id;
        }

        // find corresponding samlanGateway
        var parentSerial = this.samlanParentSerials[unitID];
        if (parentSerial === undefined || parentSerial == this.samlanAgg.get('serial')) {
            return this.options.parentDevice.id;
        }
        return this.samlanGateways[parentSerial].deviceID;
    },

    save: function (e) {
        e.preventDefault();
        this.inAdding = true;
        this.render();

        this.scanCount = 0;
        this.scanMaxSteps = this.devices.length + Object.keys(this.samlanGateways).length;

        this.scanCancelled = true;
        this.unitIDcurrent = 0;
        this.unitIDmax = this.devices.length;

        this.triggerAddDevice();
    },
});

module.exports = ScanDevicesDialogView;
